var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\r\n\t\t.st0{clip-path:url(#SVGID_00000155864254345703963960000007216152645563816629_);fill:url(#SVGID_00000172439900543599509500000000955968371381021622_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M6.85,13.36c-0.41,0-0.74,0.33-0.74,0.74v2.81c0,0.41,0.33,0.74,0.74,0.74h2.81c0.41,0,0.74-0.33,0.74-0.74 v-2.81c0-0.41-0.33-0.74-0.74-0.74H6.85z M14.44,13.36c-0.41,0-0.74,0.33-0.74,0.74v2.81c0,0.41,0.33,0.74,0.74,0.74h2.81 c0.41,0,0.75-0.33,0.75-0.74v-2.81c0-0.41-0.33-0.74-0.75-0.74H14.44z M6.85,6C6.44,6,6.1,6.33,6.1,6.74v2.81 c0,0.41,0.33,0.74,0.74,0.74h2.81c0.41,0,0.74-0.33,0.74-0.74V6.74C10.4,6.33,10.07,6,9.66,6H6.85z M14.44,6 c-0.41,0-0.74,0.33-0.74,0.74v2.81c0,0.41,0.33,0.74,0.74,0.74h2.81c0.41,0,0.75-0.33,0.75-0.74V6.74C18,6.33,17.66,6,17.25,6 H14.44z M4.85,16.92v-2.81c0-1.1,0.9-1.99,2-1.99h2.81c1.1,0,1.99,0.9,1.99,1.99v2.81c0,1.1-0.89,2-1.99,2H6.85 C5.75,18.92,4.85,18.02,4.85,16.92 M12.44,16.92v-2.81c0-1.1,0.9-1.99,2-1.99h2.81c1.1,0,2,0.9,2,1.99v2.81c0,1.1-0.9,2-2,2h-2.81 C13.34,18.92,12.44,18.02,12.44,16.92 M4.85,9.55V6.74c0-1.1,0.9-2,2-2h2.81c1.1,0,1.99,0.9,1.99,2v2.81c0,1.1-0.89,2-1.99,2H6.85 C5.75,11.55,4.85,10.65,4.85,9.55 M12.44,9.55V6.74c0-1.1,0.9-2,2-2h2.81c1.1,0,2,0.9,2,2v2.81c0,1.1-0.9,2-2,2h-2.81 C13.34,11.55,12.44,10.65,12.44,9.55 M12,0C5.37,0,0,5.37,0,12s5.37,12,12,12s12-5.37,12-12C23.99,5.38,18.62,0.01,12,0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042734764697402517710000013931243667219152273_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018198647988198642860000014749826045252503208_",
    gradientUnits: "userSpaceOnUse",
    x1: -9.094947e-13,
    y1: 24,
    x2: 1,
    y2: 24,
    gradientTransform: "matrix(24 0 0 24 0 -564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFA68D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FD3A84"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      clipPath: "url(#SVGID_00000042734764697402517710000013931243667219152273_)",
      fill: "url(#SVGID_00000018198647988198642860000014749826045252503208_)"
    },
    width: 24,
    height: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.15cbc076a0df92f90445b30aa670b886.svg";
export { ForwardRef as ReactComponent };